var userInfo = false;
var userRef;
var userFirstName;
var userSurname

firebase.auth().onAuthStateChanged(function(user) {
    if (user) {
        getUserInfo(user)
        if (page === 'admin'){
            $('.admin-container').removeClass('d-none')
        }
        if (page === 'adLog'){
             window.location = '/admin/'
        }
    } else {
        userInfo = false;
        $(".user-fullName").html(
            '<span onclick="openLoginModal()">Login</span>'
        );
        $(".signup-item").html(
            '<span onclick="turnToSignUpForm()">Registrati</span>'
        );
        if (page === 'admin'){
            window.location = '/'
        }
    }
});

const login = (checkout) => {
    let email = $('#loginEmail').val();
    let password = $('#loginPassword').val();
    firebase.auth()
        .signInWithEmailAndPassword(email, password)
        .then(() => {
            closeModal()
            if (checkout) {
                setTimeout(function () {
                    openCheckoutModal();
                }, 500);
            }
        })
        .catch(function(error) {
    });
}

const signUp = (checkout) => {
    userFirstName = $('#name').val();
    userSurname = $('#surname').val();
    let email = $('#loginEmail').val();
    let password = $('#loginPassword').val();
    firebase.auth().createUserWithEmailAndPassword(email, password).then(() => {
        closeModal();
    })
}

const logout = () => {
    firebase.auth().signOut()
    .then(function() {
        userInfo = false;
        $(".user-fullName").html(
            '<span onClick="openLoginModal()">Login</span>'
        );
        closeProductModal();
    })
}

const getMenu = (role) => {
    let menu;
    if (role === 'admin'){
        menu = `
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                <a class="dropdown-item" onClick="logout()">Logout</a>
            </div>
        `
    } else {
        menu = `
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                <a class="dropdown-item" href="/shop/">Shop</a>
                <a class="dropdown-item" href="/shop/orders/">I miei ordini</a>
                <a class="dropdown-item" onclick="openCartModal()">Carrello</a>
                <a class="dropdown-item" onClick="logout()">Logout</a>
            </div>
        `
    }
    return menu
}

const getUserInfo = (user) => {
    userInfo = {};
    userRef = database.ref('users/' + user.uid);
    userRef.on('value', function(userSnap){
        let userVal = userSnap.val();
        if (userVal !== undefined && userVal !== null){
            userInfo = {
                uid : user.uid,
                email: user.email,
                fullName : userVal.name + ' ' + userVal.surname,
                role : userVal.role,
                address : userVal.address,
                role : userVal.role
            }
            var userLogged = new Event('userLogged');
            window.dispatchEvent(userLogged);
            if (userInfo.role !== 'admin' && page === 'admin'){
                window.location = '/'
            }
            $(".signup-item").html('')
            $(".user-fullName").html(`
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    ${userInfo.fullName}
                </a>
                ${getMenu(userInfo.role)}
                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                    <a class="dropdown-item" href="/shop/">Shop</a>
                    <a class="dropdown-item" href="/shop/orders/">I miei ordini</a>
                    <a class="dropdown-item" onclick="openCartModal()">Carrello</a>
                    <a class="dropdown-item" onClick="logout()">Logout</a>
                </div>
                `);
        } else {
            userRef.set({
                uid : user.uid,
                email: user.email,
                name : userFirstName ,
                surname : userSurname,
                role : 'user',
                address : false
            }).then(() => {
                $(".user-fullName").html(`
                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        ${userFirstName + ' ' + userSurname}
                    </a>
                    <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <a class="dropdown-item" href="/shop/">Shop</a>
                        <a class="dropdown-item" href="/shop/orders/">I miei ordini</a>
                        <a class="dropdown-item" onclick="openCartModal()">Carrello</a>
                        <a class="dropdown-item" onClick="logout()">Logout</a>
                    </div>
                    `);
            })
        }

    })
}

{/* <a class="dropdown-item" href="/shop/profile/">Gestisci Profilo</a> */}
